import { render, staticRenderFns } from "./MyAccountMenu.vue?vue&type=template&id=48fd27a0&scoped=true"
import script from "./MyAccountMenu.vue?vue&type=script&lang=js"
export * from "./MyAccountMenu.vue?vue&type=script&lang=js"
import style0 from "./MyAccountMenu.vue?vue&type=style&index=0&id=48fd27a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fd27a0",
  null
  
)

export default component.exports